const footballPatterns = [
  {
    pattern: /^\((.+?)\) - (.*?) Total Corners Over\/Under$/i,
    key: 'timeRangeTeamTotalCornersOverUnder',
    params: ['time', 'team'],
  },
  {
    pattern: /^Rest of the Match \((.+?)\)$/i,
    key: 'restOfTheMatch',
    params: ['score'],
  },
  { pattern: /^\((.+?)\) - What will Happen$/i, key: 'timeRangeWhatWillHappen', params: ['time'] },
  { pattern: /^\((.+?)\) - What will Happen First$/i, key: 'timeRangeWhatWillHappenFirst', params: ['time'] },
  { pattern: /^\((.+?)\) - Both Teams To$/i, key: 'timeRangeBothTeamsTo', params: ['time'] },
  { pattern: /^\((.+?)\) - Result$/i, key: 'timeRangeResult', params: ['time'] },
  { pattern: /^\((.+?)\) - Total Goals Over\/Under$/i, key: 'timeRangeTotalGoals', params: ['time'] },
  { pattern: /^\((.+?)\) - Total Corners Over\/Under$/i, key: 'timeRangeTotalCorners', params: ['time'] },

  { pattern: /^1st Half - (.*?) Total Goals Over\/Under$/i, key: 'firstHalfTeamTotalGoals', params: ['team'] },
  { pattern: /^1st Half - Asian Handicap \((.+?)\)$/i, key: 'firstHalfAsianHandicap', params: ['score'] },
  { pattern: /^1st Half - Next Team to Score \(Goal (\d+)\)$/i, key: 'firstHalfNextTeamToScore', params: ['goal'] },
  { pattern: /^1st Half - (.*?) Total Cards Over\/Under$/i, key: 'firstHalfTeamTotalCardsOverUnder', params: ['team'] },
  { pattern: /^1st Half - (.*?) Total Cards Range$/i, key: 'firstHalfTeamTotalCardsRange', params: ['team'] },
  { pattern: /^1st Half - (.*?) Total Goals Exact$/i, key: 'firstHalfTeamTotalGoalsExact', params: ['team'] },
  {
    pattern: /^1st Half - (.*?) Total Corners Over\/Under$/i,
    key: 'firstHalfTeamTotalCornersOverUnder',
    params: ['team'],
  },

  { pattern: /^2nd Half - (.*?) Total Goals Over\/Under$/i, key: 'secondHalfTeamTotalGoals', params: ['team'] },
  { pattern: /^2nd Half - Asian Handicap \((.+?)\)$/i, key: 'secondHalfAsianHandicap', params: ['score'] },
  { pattern: /^2nd Half - Next Team to Score \(Goal (\d+)\)$/i, key: 'secondHalfNextTeamToScore', params: ['goal'] },
  {
    pattern: /^2nd Half - (.*?) Total Cards Over\/Under$/i,
    key: 'secondHalfTeamTotalCardsOverUnder',
    params: ['team'],
  },
  { pattern: /^2nd Half - (.*?) Total Cards Range$/i, key: 'secondHalfTeamTotalCardsRange', params: ['team'] },
  { pattern: /^2nd Half - (.*?) Total Goals Exact$/i, key: 'secondHalfTeamTotalGoalsExact', params: ['team'] },
  {
    pattern: /^2nd Half - (.*?) Total Corners Over\/Under$/i,
    key: 'secondHalfTeamTotalCornersOverUnder',
    params: ['team'],
  },

  {
    pattern: /^(?!1st Period - |2nd Period - |3rd Period - )(.*?) Total Goals Over\/Under$/i,
    key: 'teamTotalGoals',
    params: ['team'],
  },
  { pattern: /^Asian Handicap \((.+?)\)$/i, key: 'asianHandicap', params: ['score'] },
  { pattern: /^Both Teams to Receive (\d+)\+ Cards$/i, key: 'bothTeamsToReceiveCards', params: ['cards'] },
  {
    pattern: /^(?!1st Period - |2nd Period - |3rd Period - )(.*?) Total Goals Exact$/i,
    key: 'teamTotalGoalsExact',
    params: ['team'],
  },
  { pattern: /^(.*?) Total Cards Over\/Under$/i, key: 'teamTotalCardsOverUnder', params: ['team'] },
  { pattern: /^(.*?) Total Cards Range$/i, key: 'teamTotalCardsRange', params: ['team'] },
  { pattern: /^(.*?) Total Fouls Over\/Under$/i, key: 'teamTotalFoulsOverUnder', params: ['team'] },
  { pattern: /^(.*?) Total Goal Kicks Over\/Under$/i, key: 'teamTotalGoalKicksOverUnder', params: ['team'] },
  { pattern: /^(.*?) Total Offsides Over\/Under$/i, key: 'teamTotalOffsidesOverUnder', params: ['team'] },
  { pattern: /^(.*?) Total Shots on Target Over\/Under$/i, key: 'teamTotalShotsOnTargetOverUnder', params: ['team'] },
  { pattern: /^(.*?) Total Shots Over\/Under$/i, key: 'teamTotalShotsOverUnder', params: ['team'] },
  { pattern: /^(.*?) Total Tackles Over\/Under$/i, key: 'teamTotalTacklesOverUnder', params: ['team'] },
  { pattern: /^(.*?) Total Throw-ins Over\/Under$/i, key: 'teamTotalThrowInsOverUnder', params: ['team'] },
  { pattern: /^(.*?) to Win Both Halves$/i, key: 'teamToWinBothHalves', params: ['team'] },
  { pattern: /^(.*?) to Score in Both Halves$/i, key: 'teamToScoreInBothHalves', params: ['team'] },
  { pattern: /^(.*?) Penalty Awarded$/i, key: 'teamPenaltyAwarded', params: ['team'] },
  { pattern: /^(.*?) First Goalscorer$/i, key: 'teamFirstGoalscorer', params: ['team'] },
  {
    pattern: /^Next Team to Score \(Goal (\d+)\) \(incl\. Overtime\)$/i,
    key: 'nextTeamToScoreGoalInclOvertime',
    params: ['goal'],
  },
  {
    pattern: /^(.*?) Next Goal Before (\d{1,2}(?::\d{2})?) Minute \(Goal (\d+)\)$/i,
    key: 'teamNextGoalBeforeMinute',
    params: ['team', 'minute', 'goal'],
  },
  { pattern: /^(.*?) Time of Next Goal \(Goal (\d+)\)$/i, key: 'teamTimeOfNextGoal', params: ['team', 'goal'] },
  { pattern: /^(.*?) to Come From Behind and Win$/i, key: 'teamToComeFromBehindAndWin', params: ['team'] },

  { pattern: /^Player to Give (\d+)\+ Passes$/i, key: 'playerToRecordPasses', params: ['passes'] },
  { pattern: /^Player to Give (\d+)\+ Assists$/i, key: 'playerToRecordAssists', params: ['assists'] },
  { pattern: /^Player to Record (\d+)\+ Shots$/i, key: 'playerToRecordShots', params: ['shots'] },
  { pattern: /^Player to Record (\d+)\+ Tackles$/i, key: 'playerToRecordTackles', params: ['tackles'] },
  { pattern: /^Player to Score (\d+)\+ Goals$/i, key: 'playerToScoreGoals', params: ['goals'] },

  {
    pattern: /^Time of 1st Goal Over\/Under (\d+(?:\.\d+)?|\d{1,2}:\d{2}) Minutes$/i,
    key: 'timeOfFirstGoalOverUnder',
    params: ['minutes'],
  },
  {
    pattern: /^Time of 1st Goal Over\/Under (\d+) Minutes$/i,
    key: 'timeOfFirstGoalOverUnder',
    params: ['minutes'],
  },
  {
    pattern: /^Time of Next Goal \(Goal (\d+)\)$/i,
    key: 'timeOfNextGoal',
    params: ['goal'],
  },
  {
    pattern: /^Next Team to Score \(Goal (\d+)\)$/i,
    key: 'nextTeamToScore',
    params: ['goal'],
  },
  {
    pattern: /^Method of Goal Score \(Goal (\d+)\)$/i,
    key: 'methodOfGoalScore',
    params: ['goal'],
  },
  {
    pattern: /^Next Goal Before (\d{1,2}(?::\d{2})?) Minute \(Goal 1\)$/i,
    key: 'nextGoalBeforeMinute',
    params: ['minute'],
  },
  { pattern: /^First Goal Before (\d{1,2}(?::\d{2})?)$/i, key: 'firstGoalBeforeMinute', params: ['minute'] },
  { pattern: /^First Card Before (\d{1,2}(?::\d{2})?)$/i, key: 'firstCardBeforeMinute', params: ['minute'] },
  { pattern: /^First to Happen after (\d{1,2}(?::\d{2})?)$/i, key: 'firstToHappenAfterMinute', params: ['minute'] },
  { pattern: /^Goal Scored after (\d{1,2}(?::\d{2})?)$/i, key: 'goalScoredAfterMinute', params: ['minute'] },

  {
    pattern: /^Over (\d+(?:\.\d+)?) Goals Scored in Both Halves$/i,
    key: 'overGoalsScoredInBothHalves',
    params: ['goals'],
  },
  {
    pattern: /^Under (\d+(?:\.\d+)?) Goals Scored in Both Halves$/i,
    key: 'underGoalsScoredInBothHalves',
    params: ['goals'],
  },
  {
    pattern: /^Both Teams to Score and Total Goals Over\/Under (\d+(?:\.\d+)?)$/i,
    key: 'bothTeamsToScoreAndTotalGoalsOverUnder',
    params: ['goals'],
  },
  {
    pattern: /^Both Teams to Score or Total Goals Over (\d+(?:\.\d+)?)$/i,
    key: 'bothTeamsToScoreOrTotalGoalsOver',
    params: ['goals'],
  },
  {
    pattern: /^Match Result and Total Goals Over\/Under (\d+(?:\.\d+)?)$/i,
    key: 'matchResultAndTotalGoalsOverUnder',
    params: ['goals'],
  },
  {
    pattern: /^Match Result or Total Goals Over\/Under (\d+(?:\.\d+)?)$/i,
    key: 'matchResultOrTotalGoalsOverUnder',
    params: ['goals'],
  },
  {
    pattern: /^Double Chance and Total Goals Over\/Under (\d+(?:\.\d+)?)$/i,
    key: 'doubleChanceAndTotalGoalsOverUnder',
    params: ['goals'],
  },

  { pattern: /^Race to (\d+) Cards$/i, key: 'raceToXCards', params: ['cards'] },
  { pattern: /^Race to (\d+) Corners$/i, key: 'raceToXCorners', params: ['corners'] },
  { pattern: /^Race to (\d+) Goals$/i, key: 'raceToXGoals', params: ['goals'] },

  { pattern: /^Goalkeeper to Record (\d+)\+ Saves$/i, key: 'goalkeeperToRecordSaves', params: ['saves'] },
  { pattern: /^(.*?) Red Card$/i, key: 'teamRedCard', params: ['team'] },
  { pattern: /^(.*?) Total Corners Over\/Under$/i, key: 'teamTotalCornersOverUnder', params: ['team'] },
  {
    pattern: /^(.*?) Next Goal Before X Minute \(Goal (\d+)\)$/i,
    key: 'teamNextGoalBeforeMinute',
    params: ['team', 'goal'],
  },
  { pattern: /^Next Card \(Card (\d+)\)$/i, key: 'nextCard', params: ['card'] },
  { pattern: /^Next Corner \(Corner (\d+)\)$/i, key: 'nextCorner', params: ['corner'] },
  { pattern: /^Next Goal Before X Minute \(Goal (\d+)\)$/i, key: 'nextGoalBeforeXMinute', params: ['goal'] },
];

const basketballPatterns = [
  {
    pattern: /^1st Half - (.*?) Total Points Over\/Under$/i,
    key: 'firstHalfTeamTotalPointsOverUnder',
    params: ['team'],
  },
  {
    pattern: /^2nd Half - (.*?) Total Points Over\/Under$/i,
    key: 'secondHalfTeamTotalPointsOverUnder',
    params: ['team'],
  },
  {
    pattern: /^1st Quarter - (.*?) Total Points Over\/Under$/i,
    key: 'firstQuarterTeamTotalPointsOverUnder',
    params: ['team'],
  },
  {
    pattern: /^2nd Quarter - (.*?) Total Points Over\/Under$/i,
    key: 'secondQuarterTeamTotalPointsOverUnder',
    params: ['team'],
  },
  {
    pattern: /^3rd Quarter - (.*?) Total Points Over\/Under$/i,
    key: 'thirdQuarterTeamTotalPointsOverUnder',
    params: ['team'],
  },
  {
    pattern: /^4th Quarter - (.*?) Total Points Over\/Under$/i,
    key: 'fourthQuarterTeamTotalPointsOverUnder',
    params: ['team'],
  },

  { pattern: /^(?!Game )(.*?) Total Points Over\/Under$/i, key: 'teamTotalPointsOverUnder', params: ['team'] },
  { pattern: /^(?!Game )(.*?) Total Points Odd\/Even$/i, key: 'teamTotalPointsOddEven', params: ['team'] },
  { pattern: /^(.*?) Total Assists Over\/Under$/i, key: 'teamTotalAssistsOverUnder', params: ['team'] },
  { pattern: /^(.*?) Total Blocks Over\/Under$/i, key: 'teamTotalBlocksOverUnder', params: ['team'] },
  { pattern: /^(.*?) Total Rebounds Over\/Under$/i, key: 'teamTotalReboundsOverUnder', params: ['team'] },
  { pattern: /^(.*?) Total Steals Over\/Under$/i, key: 'teamTotalStealsOverUnder', params: ['team'] },
  {
    pattern: /^(.*?) Total Two-Points Shots Attempted Over\/Under$/i,
    key: 'teamTotalTwoPointsShotsAttemptedOverUnder',
    params: ['team'],
  },
  {
    pattern: /^(.*?) Total Defensive Rebounds Over\/Under$/i,
    key: 'teamTotalDefensiveReboundsOverUnder',
    params: ['team'],
  },
  {
    pattern: /^(.*?) Total Offensive Rebounds Over\/Under$/i,
    key: 'teamTotalOffensiveReboundsOverUnder',
    params: ['team'],
  },
  { pattern: /^(.*?) Total Fouls Over\/Under$/i, key: 'teamTotalFoulsOverUnder', params: ['team'] },
  { pattern: /^(.*?) Total Turnovers Over\/Under$/i, key: 'teamTotalTurnoversOverUnder', params: ['team'] },
  {
    pattern: /^(.*?) Total Three-Point Shots Scored Over\/Under$/i,
    key: 'teamTotalThreePointShotsScoredOverUnder',
    params: ['team'],
  },
  {
    pattern: /^(.*?) Total Three-Point Shots Attempted Over\/Under$/i,
    key: 'teamTotalThreePointShotsAttemptedOverUnder',
    params: ['team'],
  },
  {
    pattern: /^(.*?) Total Two-Point Shots Scored Over\/Under$/i,
    key: 'teamTotalTwoPointShotsScoredOverUnder',
    params: ['team'],
  },
  {
    pattern: /^(.*?) Total Two-Point Shots Attempted Over\/Under$/i,
    key: 'teamTotalTwoPointShotsAttemptedOverUnder',
    params: ['team'],
  },
  {
    pattern: /^(.*?) Total Free Throws Scored Over\/Under$/i,
    key: 'teamTotalFreeThrowsScoredOverUnder',
    params: ['team'],
  },
  {
    pattern: /^(.*?) Total Free Throws Attempted Over\/Under$/i,
    key: 'teamTotalFreeThrowsAttemptedOverUnder',
    params: ['team'],
  },

  { pattern: /^Total Points Range (\d+)-Way$/i, key: 'totalPointsRangeWay', params: ['way'] },
  { pattern: /^Winning Margin (\d+)-Way$/i, key: 'winningMarginWay', params: ['way'] },
  { pattern: /^Any Team Winning Margin (\d+)-Way$/i, key: 'anyTeamWinningMarginWay', params: ['way'] },

  { pattern: /^Total Points H2H - (\d+)$/i, key: 'totalPointsH2H', params: ['number'] },
  { pattern: /^Total Rebounds H2H - (\d+)$/i, key: 'totalReboundsH2H', params: ['number'] },
];

const tennisPatterns = [
  {
    pattern: /^Set (\d+) - Game (\d+) - Correct Score$/i,
    key: 'setNumberGameNumberCorrectScore',
    params: ['number', 'game'],
  },
  {
    pattern: /^Set (\d+) - Game (\d+) - Correct Score after (\d+) Points$/i,
    key: 'setNumberGameNumberCorrectScoreAfterPoints',
    params: ['number', 'game', 'points'],
  },
  {
    pattern: /^Set (\d+) - Game (\d+) - Winner$/i,
    key: 'setNumberGameNumberWinner',
    params: ['number', 'game'],
  },
  {
    pattern: /^Set (\d+) - Game (\d+) - Point (\d+) Winner$/i,
    key: 'setNumberGameNumberPointNumberWinner',
    params: ['set', 'game', 'point'],
  },
  {
    pattern: /^Set (\d+) - Total Games Odd\/Even$/i,
    key: 'setNumberTotalGamesOddEven',
    params: ['number'],
  },
  {
    pattern: /^Set (\d+) - Winner$/i,
    key: 'setNumberWinner',
    params: ['number'],
  },
  {
    pattern: /^Set (\d+) - Winner and Total Games Over\/Under$/i,
    key: 'setNumberWinnerAndTotalGamesOverUnder',
    params: ['number'],
  },
  {
    pattern: /^Set (\d+) - Correct Score$/i,
    key: 'setNumberCorrectScore',
    params: ['number'],
  },
  {
    pattern: /^Set (\d+) - Correct Score after (\d+) Games$/i,
    key: 'setNumberCorrectScoreAfterGames',
    params: ['number', 'games'],
  },
  {
    pattern: /^Set (\d+) - Correct Score Group$/i,
    key: 'setNumberCorrectScoreGroup',
    params: ['number'],
  },
  {
    pattern: /^Set (\d+) - Duration Over\/Under$/i,
    key: 'setNumberDurationOverUnder',
    params: ['number'],
  },
  {
    pattern: /^Set (\d+) - Handicap$/i,
    key: 'setNumberHandicap',
    params: ['number'],
  },
  {
    pattern: /^(.*?) First Serve in Percentage \(%\)$/i,
    key: 'playerFirstServePercentage',
    params: ['player'],
  },
  {
    pattern: /^(.*?) Service Game (\d+) - Winner$/i,
    key: 'playerServiceGameWinner',
    params: ['player', 'number'],
  },
  {
    pattern: /^(.*?) Total Aces and Double Faults Exact$/i,
    key: 'playerTotalAcesAndDoubleFaultsExact',
    params: ['player'],
  },
  {
    pattern: /^(.*?) Total Aces and Double Faults Over\/Under$/i,
    key: 'playerTotalAcesAndDoubleFaultsOverUnder',
    params: ['player'],
  },
  {
    pattern: /^(.*?) Total Aces Exact$/i,
    key: 'playerTotalAcesExact',
    params: ['player'],
  },
  {
    pattern: /^(.*?) Total Aces Over\/Under$/i,
    key: 'playerTotalAcesOverUnder',
    params: ['player'],
  },
  {
    pattern: /^(.*?) Total Breaks Over\/Under$/i,
    key: 'playerTotalBreaksOverUnder',
    params: ['player'],
  },
  {
    pattern: /^(.*?) Total Double Faults Exact$/i,
    key: 'playerTotalDoubleFaultsExact',
    params: ['player'],
  },
  {
    pattern: /^(.*?) Total Double Faults Over\/Under$/i,
    key: 'playerTotalDoubleFaultsOverUnder',
    params: ['player'],
  },
  {
    pattern: /^(.*?) Total Games Over\/Under$/i,
    key: 'playerTotalGamesOverUnder',
    params: ['player'],
  },
  {
    pattern: /^(.*?) to Win (\d+)\+ Sets$/i,
    key: 'playerToWinSets',
    params: ['player', 'number'],
  },
  {
    pattern: /^(.*?) to Win after Being Behind on Sets$/i,
    key: 'playerToWinAfterBeingBehindOnSets',
    params: ['player'],
  },
  {
    pattern: /^Set (\d+) - (.*?) Total Aces and Double Faults Over\/Under$/i,
    key: 'setNumberPlayerTotalAcesAndDoubleFaultsOverUnder',
    params: ['number', 'player'],
  },
  {
    pattern: /^Set (\d+) - (.*?) Total Aces Over\/Under$/i,
    key: 'setNumberPlayerTotalAcesOverUnder',
    params: ['number', 'player'],
  },
  {
    pattern: /^Set (\d+) - (.*?) Total Breaks Over\/Under$/i,
    key: 'setNumberPlayerTotalBreaksOverUnder',
    params: ['number', 'player'],
  },
  {
    pattern: /^Set (\d+) - (.*?) Total Double Faults Over\/Under$/i,
    key: 'setNumberPlayerTotalDoubleFaultsOverUnder',
    params: ['number', 'player'],
  },
  {
    pattern: /^Set (\d+) - (.*?) Total Games Over\/Under$/i,
    key: 'setNumberPlayerTotalGamesOverUnder',
    params: ['number', 'player'],
  },
  {
    pattern: /^Set (\d+) - (.*?) Total Games Exact$/i,
    key: 'setNumberPlayerTotalGamesExact',
    params: ['number', 'player'],
  },
  {
    pattern: /^Set (\d+) - (.*?) to Break$/i,
    key: 'setNumberPlayerToBreak',
    params: ['number', 'player'],
  },
  {
    pattern: /^Set (\d+) - Game (\d+) - Server to Win to 0 or 15$/i,
    key: 'setNumberGameNumberServerToWinTo0Or15',
    params: ['set', 'game'],
  },
  {
    pattern: /^Set (\d+) - Game (\d+) - Server to Win to 0 or 15 or 30$/i,
    key: 'setNumberGameNumberServerToWinTo0Or15Or30',
    params: ['set', 'game'],
  },
  {
    pattern: /^Set (\d+) - Game (\d+) - To go to Deuce$/i,
    key: 'setNumberGameNumberToGoToDeuce',
    params: ['set', 'game'],
  },
  {
    pattern: /^Set (\d+) - Race To (\d+) Games$/i,
    key: 'setNumberRaceToXGames',
    params: ['set', 'games'],
  },
];

const hockeyPatterns = [
  {
    pattern: /^\((.+?)\) - Goal Scored$/i,
    key: 'timeRangeGoalScored',
    params: ['time'],
  },
  {
    pattern: /^(\d+)\+ Goals in All Periods$/i,
    key: 'goalsInAllPeriods',
    params: ['goals'],
  },
  {
    pattern: /^1st Period - (.*?) No Bet$/i,
    key: 'firstPeriodTeamNoBet',
    params: ['team'],
  },
  {
    pattern: /^1st Period - (.*?) to Score$/i,
    key: 'firstPeriodTeamToScore',
    params: ['team'],
  },
  {
    pattern: /^1st Period - (.*?) Total Goals Over\/Under$/i,
    key: 'firstPeriodTeamTotalGoalsOverUnder',
    params: ['team'],
  },
  {
    pattern: /^1st Period - Next Team to Score \(Goal (\d+)\)$/i,
    key: 'firstPeriodNextTeamToScoreGoal',
    params: ['goal'],
  },
  {
    pattern: /^2nd Period - (.*?) No Bet$/i,
    key: 'secondPeriodTeamNoBet',
    params: ['team'],
  },
  {
    pattern: /^2nd Period - (.*?) to Score$/i,
    key: 'secondPeriodTeamToScore',
    params: ['team'],
  },
  {
    pattern: /^2nd Period - (.*?) Total Goals Over\/Under$/i,
    key: 'secondPeriodTeamTotalGoalsOverUnder',
    params: ['team'],
  },
  {
    pattern: /^2nd Period - Next Team to Score \(Goal (\d+)\)$/i,
    key: 'secondPeriodNextTeamToScoreGoal',
    params: ['goal'],
  },
  {
    pattern: /^3rd Period - (.*?) No Bet$/i,
    key: 'thirdPeriodTeamNoBet',
    params: ['team'],
  },
  {
    pattern: /^3rd Period - (.*?) to Score$/i,
    key: 'thirdPeriodTeamToScore',
    params: ['team'],
  },
  {
    pattern: /^3rd Period - (.*?) Total Goals Over\/Under$/i,
    key: 'thirdPeriodTeamTotalGoalsOverUnder',
    params: ['team'],
  },
  {
    pattern: /^3rd Period - Next Team to Score \(Goal (\d+)\)$/i,
    key: 'thirdPeriodNextTeamToScoreGoal',
    params: ['goal'],
  },
  {
    pattern: /^(.*?) & (.*?) Both to Record (\d+)\+ Assists \(incl\. Overtime\)$/i,
    key: 'playersBothToRecordAssistsInclOvertime',
    params: ['player1', 'player2', 'assists'],
  },
  {
    pattern: /^(.*?) & (.*?) Both to Score (\d+)\+ Power Play Points \(incl\. Overtime\)$/i,
    key: 'playersBothToScorePowerPlayPointsInclOvertime',
    params: ['player1', 'player2', 'points'],
  },
  {
    pattern: /^(.*?) & (.*?) Both to Score (\d+)\+ Goals \(incl\. Overtime\)$/i,
    key: 'playersBothToScoreGoalsInclOvertime',
    params: ['player1', 'player2', 'goals'],
  },
  {
    pattern: /^(.*?) & (.*?) Both to Have (\d+)\+ Shots on Target \(incl\. Overtime\)$/i,
    key: 'playersBothToHaveShotsOnTargetInclOvertime',
    params: ['player1', 'player2', 'shots'],
  },
  {
    pattern: /^(.*?) & (.*?) Both to Have (\d+)\+ Saves \(incl\. Overtime\)$/i,
    key: 'playersBothToHaveSavesInclOvertime',
    params: ['player1', 'player2', 'saves'],
  },
  {
    pattern: /^(.*?) Highest Scoring Period$/i,
    key: 'teamHighestScoringPeriod',
    params: ['team'],
  },
  {
    pattern: /^(.*?) No Bet \(Regular Time\)$/i,
    key: 'teamNoBetRegularTime',
    params: ['team'],
  },
  {
    pattern: /^(.*?) to Score in All Periods$/i,
    key: 'teamToScoreInAllPeriods',
    params: ['team'],
  },
  {
    pattern: /^(.*?) to Score \(Regular Time\)$/i,
    key: 'teamToScoreRegularTime',
    params: ['team'],
  },
  {
    pattern: /^(.*?) Total Goals Exact \(incl\. Overtime & Penalties\)$/i,
    key: 'teamTotalGoalsExactInclOvertimePenalties',
    params: ['team'],
  },
  {
    pattern: /^(.*?) Total Goals Exact \(Regular Time\)$/i,
    key: 'teamTotalGoalsExactRegularTime',
    params: ['team'],
  },
  {
    pattern: /^(.*?) Total Goals Odd\/Even \(Regular Time\)$/i,
    key: 'teamTotalGoalsOddEvenRegularTime',
    params: ['team'],
  },
  {
    pattern: /^(.*?) Total Goals Over\/Under \(Including Overtime & Penalties\)$/i,
    key: 'teamTotalGoalsOverUnderInclOvertimePenalties',
    params: ['team'],
  },
  {
    pattern: /^(.*?) Total Goals Over\/Under \(Regular Time\)$/i,
    key: 'teamTotalGoalsOverUnderRegularTime',
    params: ['team'],
  },
  {
    pattern: /^(.*?) Total Goals Range \(Regular Time\)$/i,
    key: 'teamTotalGoalsRangeRegularTime',
    params: ['team'],
  },
  {
    pattern: /^(.*?) to Win All Periods$/i,
    key: 'teamToWinAllPeriods',
    params: ['team'],
  },
  {
    pattern: /^(.*?) to Win Any Period$/i,
    key: 'teamToWinAnyPeriod',
    params: ['team'],
  },
  {
    pattern: /^(.*?) to Win to Nil \(incl\. Overtime\)$/i,
    key: 'teamToWinToNilInclOvertime',
    params: ['team'],
  },
  {
    pattern: /^Match Winner and (.*?) Total Goals Over\/Under \(incl\. Overtime & Penalties\)$/i,
    key: 'matchWinnerAndTeamTotalGoalsOverUnderInclOvertimePenalties',
    params: ['team'],
  },
  {
    pattern: /^Both Teams to Score (\d+)\+ Goals \(incl\. Overtime\)$/i,
    key: 'bothTeamsToScoreNPlusGoalsInclOvertime',
    params: ['goals'],
  },
  {
    pattern: /^Match Result and Total Goals Over\/Under ([\d.]+) \(Regular Time\)$/i,
    key: 'matchResultAndTotalGoalsOverUnderRegularTime',
    params: ['total'],
  },
];

const otherPatterns = [
  {
    pattern: /^(.*?) to Win at Least (\d+) Set[s]?$/i,
    key: 'teamToWinAtLeastNumberSets',
    params: ['team', 'number'],
  },
  {
    pattern: /^(.*?) to Win Exactly (\d+)$/,
    key: 'teamToWinExactlyNumber',
    params: ['team', 'number'],
  },
  {
    pattern: /^(.*?) to Win Exactly (\d+) Set[s]?$/i,
    key: 'teamToWinExactlyNumberSets',
    params: ['team', 'number'],
  },
  {
    pattern: /^(.*?) Total 180s Over\/Under$/i,
    key: 'playerTotal180sOverUnder',
    params: ['player'],
  },
  {
    pattern: /^Set (\d+) - Correct Score$/i,
    key: 'setCorrectScore',
    params: ['set'],
  },
  {
    pattern: /^Set (\d+) - Legs Handicap$/i,
    key: 'setLegsHandicap',
    params: ['set'],
  },
  {
    pattern: /^Set (\d+) - Correct Score$/i,
    key: 'setCorrectScore',
    params: ['set'],
  },
  {
    pattern: /^Set (\d+) - Total Legs Over\/Under$/i,
    key: 'setTotalLegsOverUnder',
    params: ['set'],
  },
  {
    pattern: /^Game (\d+) - Handicap$/i,
    key: 'gameNumberHandicap',
    params: ['game'],
  },
  {
    pattern: /^Game (\d+) - Point (\d+) Winner$/i,
    key: 'gameNumberPointNumberWinner',
    params: ['game', 'point'],
  },
  {
    pattern: /^Game (\d+) - Race to X Points$/i,
    key: 'gameNumberRaceToXPoints',
    params: ['game'],
  },
  {
    pattern: /^Game (\d+) - Winner$/i,
    key: 'gameNumberWinner',
    params: ['game'],
  },
  {
    pattern: /^Game (\d+) - Total Points Over\/Under$/i,
    key: 'gameNumberTotalPointsOverUnder',
    params: ['game'],
  },
  {
    pattern: /^Game (\d+) - Total Points Odd\/Even$/i,
    key: 'gameNumberTotalPointsOddEven',
    params: ['game'],
  },
  {
    pattern: /^Group Round Betting (\d+)-Way$/i,
    key: 'groupRoundBettingNumberWay',
    params: ['number'],
  },
  {
    pattern: /^Round Betting (\d+)-Way$/i,
    key: 'roundBettingNumberWay',
    params: ['number'],
  },
  {
    pattern: /^Map (\d+) - Overtime$/i,
    key: 'mapOvertime',
    params: ['map'],
  },
  {
    pattern: /^Map (\d+) - Pistol Round Winner \(Round (\d+)\)$/i,
    key: 'mapPistolRoundWinner',
    params: ['map', 'round'],
  },
  {
    pattern: /^Map (\d+) - Rounds Handicap$/i,
    key: 'mapRoundsHandicap',
    params: ['map'],
  },
  {
    pattern: /^Map (\d+) - Total Rounds Over\/Under$/i,
    key: 'mapTotalRoundsOverUnder',
    params: ['map'],
  },
  {
    pattern: /^Map (\d+) - Winner$/i,
    key: 'mapWinner',
    params: ['map'],
  },
  {
    pattern: /^(.*?) to Win by Decision or Tech\. Decision$/i,
    key: 'fighterToWinByDecision',
    params: ['fighter'],
  },
  {
    pattern: /^(.*?) to Win by KO, TKO, Disqualification or Submission$/i,
    key: 'fighterToWinByFinish',
    params: ['fighter'],
  },
  {
    pattern: /^(\d+)(?:st|nd|rd|th) Inning - (.*?) Total Runs Over\/Under$/i,
    key: 'inningTeamTotalRunsOverUnder',
    params: ['inning', 'team'],
  },
  {
    pattern: /^(\d+)(?:st|nd|rd|th) Inning - Result$/i,
    key: 'inningTeamResult',
    params: ['inning'],
  },
  {
    pattern: /^(\d+) Full Innings - Handicap$/i,
    key: 'fullInningsHandicap',
    params: ['innings'],
  },
  {
    pattern: /^(\d+) Full Innings - Result$/i,
    key: 'fullInningsResult',
    params: ['innings'],
  },
  {
    pattern: /^(\d+) Full Innings - Winner \(Draw No Bet\)$/i,
    key: 'fullInningsWinnerDrawNoBet',
    params: ['innings'],
  },
  {
    pattern: /^Race to (\d+) Runs$/i,
    key: 'raceToXRuns',
    params: ['runs'],
  },
  { pattern: /^Player to Record (\d+) Hit$/i, key: 'playerToRecordXHit', params: ['number'] },
  { pattern: /^Player to Record (\d+) Run$/i, key: 'playerToRecordXRun', params: ['number'] },
  { pattern: /^Player to Record (\d+) Strikeout$/i, key: 'playerToRecordXStrikeout', params: ['number'] },
  { pattern: /^Player to Record (\d+) Earned Run$/i, key: 'playerToRecordXEarnedRun', params: ['number'] },
  { pattern: /^Player to Record (\d+) Home Run$/i, key: 'playerToRecordXHomeRun', params: ['number'] },
  { pattern: /^Map (\d+) - Race to (\d+) Kills$/i, key: 'mapNumberRaceToXKills', params: ['map', 'kills'] },
  { pattern: /^Map (\d+) - Total Kills Odd\/Even$/i, key: 'mapNumberTotalKillsOddEven', params: ['map'] },
  {
    pattern: /^Map (\d+) - To Destroy the (\d+)(?:st|nd|rd|th) Barracks$/i,
    key: 'mapNumberToDestroyXthBarracks',
    params: ['map', 'barracks'],
  },
  { pattern: /^1st Half - (.*?) Total Goals Range$/i, key: '1stHalfTeamTotalGoalsRange', params: ['team'] },
  { pattern: /^2nd Half - (.*?) Total Goals Range$/i, key: '2ndHalfTeamTotalGoalsRange', params: ['team'] },
  { pattern: /^(.*?) Total Goals Range$/i, key: 'teamTotalGoalsRange', params: ['team'] },
  { pattern: /^(.*?) Highest Scoring Half$/i, key: 'teamHighestScoringHalf', params: ['team'] },
  { pattern: /^Set (\d+) - Point (\d+) Winner$/i, key: 'setNumberPointNumberWinner', params: ['set', 'point'] },
  { pattern: /^Set (\d+) - Race to (\d+) Points$/i, key: 'setNumberRaceToXPoints', params: ['set', 'points'] },
  {
    pattern: /^(.*?) Total Points From Block Over\/Under$/i,
    key: 'teamTotalPointsFromBlockOverUnder',
    params: ['team'],
  },
  {
    pattern: /^Map (\d+) - To Destroy the (\d+)(?:st|nd|rd|th) Inhibitor$/i,
    key: 'mapNumberToDestroyXthInhibitor',
    params: ['map', 'inhibitor'],
  },
  { pattern: /^Map (\d+) - Total Kills Over\/Under$/i, key: 'mapNumberTotalKillsOverUnder', params: ['map'] },
  { pattern: /^Map (\d+) - First Blood$/i, key: 'mapNumberFirstBlood', params: ['map'] },
  { pattern: /^Map (\d+) - Kills Handicap$/i, key: 'mapNumberKillsHandicap', params: ['map'] },
  { pattern: /^Leg (\d+) - Winner$/i, key: 'legNumberWinner', params: ['leg'] },
  { pattern: /^Leg (\d+) - Any Player to Score a 180$/i, key: 'legNumberAnyPlayerToScore180', params: ['leg'] },
  { pattern: /^Leg (\d+) - Checkout Colour$/i, key: 'legNumberCheckoutColour', params: ['leg'] },
  { pattern: /^Leg (\d+) - (.*?) to Score a 180$/i, key: 'legNumberPlayerToScore180', params: ['leg', 'player'] },
  { pattern: /^Leg (\d+) - Point Range on 1 Visit$/i, key: 'legNumberPointRangeOn1Visit', params: ['leg'] },
  {
    pattern: /^Next Player to Score a 180 Succesful Attempt (180 \d+)$/i,
    key: 'nextPlayerToScore180SuccesfulAttempt',
    params: ['number'],
  },
  { pattern: /^Set (\d+) - Leg (\d+) - Winner$/i, key: 'setNumberLegNumberWinner', params: ['set', 'leg'] },
];

export const ftbPatterns = [
  ...footballPatterns,
  ...basketballPatterns,
  ...tennisPatterns,
  ...hockeyPatterns,
  ...otherPatterns,
];
